import { useQuery } from '@tanstack/react-query';

import { wishlistQuery } from './wishlistQuery';

export const useWishlist = () => useQuery(wishlistQuery());
